import {WILDCARD_ORIGIN} from 'src/origin';

import type {
  Message,
  MessageEventListenerOptions,
  TargetContext,
  TargetPostMessageOptions,
} from 'src/target/context';

/**
 * Create a TargetContext from a Window object.
 * @param win The Window object to create the TargetContext from.
 */
export function targetContextFromWindow(win: Window): TargetContext {
  return {
    ref: win,
    fromValidContext(message, opts): boolean {
      // Validate the message origin and source against the allowed values
      // TODO(imolorhe): Add tests for target contexts
      if (opts.allowedOrigin === WILDCARD_ORIGIN) {
        // If the origin is a wildcard, we allow any origin
        return true;
      }
      return (
        message.origin === opts.allowedOrigin &&
        message.source === opts.allowedSource
      );
    },
    postMessage(message: unknown, opts: TargetPostMessageOptions): void {
      win.postMessage(message, opts);
    },
    addMessageEventListener<T = unknown>(
      listener: (message: Message<T>) => void,
      {signal}: MessageEventListenerOptions,
    ): void {
      win.addEventListener('message', listener, {
        signal, // Attach the signal to allow for aborting the listener
      });
    },
    removeMessageEventListener<T = unknown>(
      listener: (message: Message<T>) => void,
    ): void {
      win.removeEventListener('message', listener);
    },
  };
}
